import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { getLink } from "../../../utils/helpers";
import Pagination from "../../general/Pagination";
import Loader from "../../general/Loader";
import { request } from "../../../utils/request";
import Modal from "../../general/Modal";
import Create from "./Create";
import Edit from "./Edit";

const tipoLabel = {
	conteo: "Conteo",
	peso: "Peso",
	volumen: "Volumen",
	longitud: "Longitud",
};

const Unidades = () => {
	const [unidades, setUnidades] = useState({
		data: [],
		links: null,
		meta: null,
	});
	const [isLoading, setIsLoading] = useState(false);
	const [showCreateModal, setCreateModal] = useState(false);
	const [showEditModal, setEditModal] = useState(false);
	const [unidadToEdit, setUnidadToEdit] = useState();
	const [filtrosQuery, setFiltrosQuery] = useState("");
	const [filtros, setFiltros] = useState({
		buscar: "",
		status: "todos",
	});

	const toggleCreateModal = () => {
		setCreateModal((state) => !state);
	};

	const toggleEditModal = (unidad) => {
		setEditModal((state) => !state);
		if (!unidad) return;

		setUnidadToEdit(unidad.id);
	};

	const getUnidadesData = (url = null) => {
		setIsLoading(true);
		url = url || "unidades";
		url += (url.includes("?") ? "&" : "?") + "limit=15";

		request(url).then((res) => {
			setUnidades(res);
			setIsLoading(false);
		});
	};

	const onFiltroChange = async (value, filtro) => {
		setFiltros((filtros) => ({
			...filtros,
			[filtro]: value,
		}));
	};

	useEffect(() => {
		getUnidadesData(`unidades${filtrosQuery}`);
	}, [filtrosQuery]);

	useEffect(() => {
		let query = Object.keys(filtros).map((fil) => {
			return `${fil}=${filtros[fil]}`;
		});

		setFiltrosQuery("?" + query.join("&"));
	}, [filtros]);

	return (
		<>
			<div className="page-header">
				<Link to={getLink("/configuracion/")}>
					&laquo; Volver a configuración
				</Link>
				<h1 className="page-title row">
					<span className="col">Unidades</span>
					<button
						className="au-btn au-btn-icon au-btn--green au-btn--small"
						onClick={toggleCreateModal}
					>
						<i className="zmdi zmdi-plus" />
						Añadir Unidad
					</button>
				</h1>
				<div className="page-controls">
					<div className="table-data__tool">
						<div className="table-data__tool-left row">
							<div className="col">
								<label htmlFor="search">Buscar</label>
								<input
									onChange={(e) =>
										onFiltroChange(e.target.value, "buscar")
									}
									type="search"
									placeholder="Buscar..."
									className="form-control"
									name="buscar"
								/>
							</div>
							<div className="col-md-2">
								<label htmlFor="status">Estado</label>
								<select
									className="form-control"
									name="status"
									id="status"
									onChange={(e) =>
										onFiltroChange(e.target.value, "status")
									}
								>
									<option value="todos">Todos</option>
									<option value="activas">Activas</option>
									<option value="inactivas">Inactivas</option>
								</select>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-md-12">
					<div>
						{isLoading && <Loader />}
						{!unidades.data?.length ? (
							<div>
								{!isLoading && (
									<div>No hay ninguna Unidad creada.</div>
								)}
							</div>
						) : (
							<div className="table-data">
								<table className="table table-data2">
									<thead>
										<tr>
											<th>Código</th>
											<th>Nombre</th>
											<th>Abreviatura</th>
											<th>Tipo</th>
											<th className="text-center">
												Estado
											</th>
											<th className="text-center">
												Acciones
											</th>
										</tr>
									</thead>
									<tbody>
										{unidades.data.map((unidad) => {
											return (
												<tr
													className="tr-shadow"
													key={unidad.id}
												>
													<td>{unidad.codigo}</td>
													<td>{unidad.nombre}</td>
													<td>{unidad.abreviatura}</td>
													<td>
														{tipoLabel[unidad.tipo] ||
															""}
													</td>
													<td className="d-flex justify-content-center">
														{unidad.activa ? (
															<span className="badge badge-success p-2">
																Activa
															</span>
														) : (
															<span className="badge badge-danger p-2">
																Inactiva
															</span>
														)}
													</td>
													<td>
														<div
															className="table-data-feature"
															style={{
																justifyContent:
																	"center",
															}}
														>
															<button
																className="item"
																data-toggle="tooltip"
																data-placement="top"
																title=""
																data-original-title="Edit"
																onClick={() => {
																	toggleEditModal(
																		unidad
																	);
																}}
															>
																<i className="zmdi zmdi-edit" />
															</button>
														</div>
													</td>
												</tr>
											);
										})}
									</tbody>
								</table>
							</div>
						)}
						{unidades.links && (
							<Pagination
								links={unidades.links}
								meta={unidades.meta}
								getData={getUnidadesData}
							/>
						)}
					</div>
				</div>
			</div>
			<Modal show={showCreateModal} blank={true} toggle={toggleCreateModal}>
				<Create
					toggleModal={toggleCreateModal}
					getUnidadesData={getUnidadesData}
				/>
			</Modal>
			<Modal
				show={showEditModal}
				blank={true}
				toggle={() => toggleEditModal()}
			>
				<Edit
					toggleModal={() => toggleEditModal()}
					getUnidadesData={getUnidadesData}
					unidadID={unidadToEdit}
				/>
			</Modal>
		</>
	);
};

export default Unidades;
